import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/cn.ts";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string; error?: string; hint?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ label, error, hint, className, id, ...props }, ref) {
    const textareaId = id ?? `ta-${Math.random().toString(36).slice(2, 9)}`;
    return (
      <div className="flex flex-col gap-1">
        {label && <label htmlFor={textareaId} className="text-[12px] font-medium text-surface-700">{label}</label>}
        <textarea ref={ref} id={textareaId}
          className={cn(
            "min-h-[80px] rounded-lg border border-surface-200 bg-white px-3 py-2 text-[13px] text-surface-900",
            "placeholder:text-surface-400 focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20 transition-colors resize-y",
            "disabled:cursor-not-allowed disabled:opacity-50",
            error && "border-danger", className,
          )} {...props} />
        {hint && !error && <p className="text-[11px] text-surface-400">{hint}</p>}
        {error && <p className="text-[11px] text-danger">{error}</p>}
      </div>
    );
  },
);
